const interventions = [
  {
    key: 'DIRECT_PRESSURE',
    category: 'BLEED_CONTROL',
    treatment: 'DIRECT_PRESSURE',
    label: {
      en: 'Direct Pressure',
    },
    availableLocations: [
      'HEAD',
      'NOSE',
      'EARS',
      'NECK',
      'MOUTH',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
  },
  {
    key: 'DRESSING_2X2',
    category: 'BLEED_CONTROL',
    treatment: 'DRESSING',
    type: '2X2',
    label: {
      en: 'Dressing 2X2',
    },
    components: [
      {
        key: 'HEMOSTATICS',
        label: {
          en: 'Hemostatics',
        },
      },
      {
        key: 'WOUND_PACKING',
        label: {
          en: 'Wound Packing',
        },
      },
    ],
    multiple: true,
    availableLocations: [
      'FACE',
      'NOSE',
      'NECK',
      'MOUTH',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
  },
  {
    key: 'DRESSING_4X4',
    category: 'BLEED_CONTROL',
    treatment: 'DRESSING',
    type: '4X4',
    label: {
      en: 'Dressing 4X4',
    },
    components: [
      {
        key: 'HEMOSTATICS',
        label: {
          en: 'Hemostatics',
        },
      },
      {
        key: 'WOUND_PACKING',
        label: {
          en: 'Wound Packing',
        },
      },
    ],
    multiple: true,
    availableLocations: [
      'FACE',
      'NOSE',
      'NECK',
      'MOUTH',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
  },
  {
    key: 'BANDAGE_ROLLER_GAUZE',
    category: 'BLEED_CONTROL',
    treatment: 'BANDAGE',
    type: 'ROLLER_GAUZE',
    label: {
      en: 'Bandage Roller Gauze',
    },
    components: [
      {
        key: 'HEMOSTATICS',
        label: {
          en: 'Hemostatics',
        },
      },
      {
        key: 'WOUND_PACKING',
        label: {
          en: 'Wound Packing',
        },
      },
    ],
    multiple: true,
    availableLocations: [
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
  },
  {
    key: 'BANDAGE_ELASTIC',
    category: 'BLEED_CONTROL',
    treatment: 'BANDAGE',
    type: 'ELASTIC',
    label: {
      en: 'Bandage Elastic',
    },
    availableLocations: [
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
    components: [
      {
        key: 'HEMOSTATICS',
        label: {
          en: 'Hemostatics',
        },
      },
      {
        key: 'WOUND_PACKING',
        label: {
          en: 'Wound Packing',
        },
      },
    ],
  },
  {
    key: 'BANDAGE_PRESSURE',
    category: 'BLEED_CONTROL',
    treatment: 'BANDAGE',
    type: 'PRESSURE',
    label: {
      en: 'Bandage Pressure',
    },
    availableLocations: [
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
    components: [
      {
        key: 'HEMOSTATICS',
        label: {
          en: 'Hemostatics',
        },
      },
      {
        key: 'WOUND_PACKING',
        label: {
          en: 'Wound Packing',
        },
      },
    ],
  },
  {
    key: 'SLING_SWATHE',
    category: 'SPLINTING',
    treatment: 'SLING_SWATHE',
    type: 'SLING_SWATHE',
    label: {
      en: 'Sling and Swathe'
    },
    availableLocations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
    ],
    availableStances: [
      'SIT',
      'LAY',
      'FOWLER',
      'SIDE',
    ],
  },
  {
    key: 'SLING',
    category: 'SPLINTING',
    treatment: 'SLING_SWATHE',
    type: 'SLING',
    label: {
      en: 'Sling'
    },
    availableLocations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
    ],
    availableStances: [
      'SIT',
      'LAY',
      'FOWLER',
      'SIDE',
    ],
  },
  {
    key: 'CHEST_SEAL',
    category: 'CHEST_WOUNDS',
    treatment: 'CHEST_SEAL',
    label: {
      en: 'Chest Seal'
    },
    availableLocations: [
      'CHEST'
    ],
  },
  {
    key: 'PETROLEUM_GAUZE',
    category: 'CHEST_WOUNDS',
    treatment: 'PETROLEUM_GAUZE',
    label: {
      en: 'Petroleum Gauze'
    },
    availableLocations: [
      'CHEST'
    ],
  },
  {
    key: 'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1',
    category: 'CHEST_WOUNDS',
    treatment: 'NEEDLE_DECOMPRESSION',
    type: 'AXILLARY_LEFT',
    label: {
      en: 'Needle Decompression Axillary Left'
    },
    availableLocations: [
      'CHEST'
    ],
    multiple: true,
    subKeys: ['NEEDLE_DECOMPRESSION_AXILLARY_LEFT_1', 'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_2', 'NEEDLE_DECOMPRESSION_AXILLARY_LEFT_3'],
    allMoulages: true,
  },
  {
    key: 'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1',
    category: 'CHEST_WOUNDS',
    treatment: 'NEEDLE_DECOMPRESSION',
    type: 'AXILLARY_RIGHT',
    label: {
      en: 'Needle Decompression Axillary Right'
    },
    availableLocations: [
      'CHEST'
    ],
    multiple: true,
    subKeys: ['NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_1', 'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_2', 'NEEDLE_DECOMPRESSION_AXILLARY_RIGHT_3'],
    allMoulages: true,
  },
  {
    key: 'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1',
    category: 'CHEST_WOUNDS',
    treatment: 'NEEDLE_DECOMPRESSION',
    type: 'CLAVICULAR_LEFT',
    label: {
      en: 'Needle Decompression Clavicular Left'
    },
    availableLocations: [
      'CHEST'
    ],
    multiple: true,
    subKeys: ['NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_1', 'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_2', 'NEEDLE_DECOMPRESSION_CLAVICULAR_LEFT_3'],
    allMoulages: true,
  },
  {
    key: 'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1',
    category: 'CHEST_WOUNDS',
    treatment: 'NEEDLE_DECOMPRESSION',
    type: 'CLAVICULAR_RIGHT',
    label: {
      en: 'Needle Decompression Clavicular Right'
    },
    availableLocations: [
      'CHEST'
    ],
    multiple: true,
    subKeys: ['NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_1', 'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_2', 'NEEDLE_DECOMPRESSION_CLAVICULAR_RIGHT_3'],
    allMoulages: true,
  },
  {
    key: 'TOURNIQUET_SINGLE',
    category: 'BLEED_CONTROL',
    treatment: 'TOURNIQUET',
    label: {
      en: 'Tourniquet'
    },
    availableLocations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
    ],
    multiple: true,
    subKeys: ['TOURNIQUET_SINGLE', 'TOURNIQUET_DOUBLE'],
  },
  {
    key: 'BANDAGE_DRY_STERILE_GAUZE',
    category: 'BURN_CARE',
    treatment: 'BANDAGE_DRY_STERILE_GAUZE',
    label: {
      en: 'Dry Sterile Gauze'
    },
    availableLocations: [
      'HEAD',
      'CHEST',
      'ABDOMEN',
      'BACK_UPPER',
      'BACK_LOWER',
      'BUTTOCKS',
      'GENITALIA',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_FOOT',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_HAND',
    ],
  },
  {
    key: 'BANDAGE_GAUZE_MITTEN_WRAP',
    category: 'BLEED_CONTROL',
    treatment: 'BANDAGE',
    type: 'GAUZE_MITTEN_WRAP',
    label: {
      en: 'Gauze Mitten Wrap',
    },
    availableLocations: [
      'LEFT_HAND',
      'RIGHT_HAND',
    ],
  },
  {
    key: 'HARE_TRACTION_SPLINT',
    category: 'SPLINTING',
    treatment: 'SPLINTING',
    type: 'HARE_TRACTION_SPLINT',
    label: {
      en: 'Hare Traction Splint',
    },
    availableLocations: [
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
    ],
    availableStances: ['LAY'],
  },
  {
    key: 'SAGER_TRACTION_SPLINT',
    category: 'SPLINTING',
    treatment: 'SPLINTING',
    type: 'SAGER_TRACTION_SPLINT',
    label: {
      en: 'Sager Traction Splint',
    },
    availableLocations: [
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
    ],
    availableStances: ['LAY'],
  },
  {
    key: 'MANUAL_STABILIZATION',
    category: 'SPLINTING',
    treatment: 'MANUAL_STABILIZATION',
    label: {
      en: 'Manual Stabilization',
    },
    availableLocations: [
      'HEAD',
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'RIGHT_HAND',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
      'LEFT_HAND',
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'RIGHT_FOOT',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
      'LEFT_FOOT',
    ],
    allMoulages: true,
  },
  {
    key: 'PADDED_BOARD_SPLINT_FULL_LEG',
    category: 'SPLINTING',
    treatment: 'PADDED_BOARD_SPLINT',
    label: {
      en: 'Padded Board Splint'
    },
    location: 'FULL_LEG',
    availableLocations: [
      'RIGHT_LEG_UPPER',
      'RIGHT_LEG_LOWER',
      'LEFT_LEG_UPPER',
      'LEFT_LEG_LOWER',
    ],
    availableStances: [
      'FOWLER',
      'LAY',
    ],
    interventionTypeMapping: [
      {
        key: 'PADDED_BOARD_SPLINT_TIE',
        label: {
          en: 'Padded Board Splint Tie'
        }
      },
      {
        key: 'PADDED_BOARD_SPLINT_TIE_BENT',
        label: {
          en: 'Padded Board Splint Tie Bent'
        }
      },
      {
        key: 'PADDED_BOARD_SPLINT_WRAP',
        label: {
          en: 'Padded Board Splint Wrap'
        }
      }
    ],
    subKeys: ['PADDED_BOARD_SPLINT_TIE', 'PADDED_BOARD_SPLINT_TIE_BENT', 'PADDED_BOARD_SPLINT_WRAP'],
  },
  {
    key: 'PADDED_BOARD_SPLINT_FULL_ARM',
    category: 'SPLINTING',
    treatment: 'PADDED_BOARD_SPLINT',
    label: {
      en: 'Padded Board Splint'
    },
    location: 'FULL_ARM',
    availableLocations: [
      'RIGHT_ARM_UPPER',
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_UPPER',
      'LEFT_ARM_LOWER',
    ],
    interventionTypeMapping: [
      {
        key: 'PADDED_BOARD_SPLINT_TIE',
        label: {
          en: 'Padded Board Splint Tie'
        }
      },
      {
        key: 'PADDED_BOARD_SPLINT_TIE_BENT',
        label: {
          en: 'Padded Board Splint Tie Bent'
        }
      },
      {
        key: 'PADDED_BOARD_SPLINT_WRAP',
        label: {
          en: 'Padded Board Splint Wrap'
        }
      }
    ],
    subKeys: ['PADDED_BOARD_SPLINT_TIE', 'PADDED_BOARD_SPLINT_TIE_BENT', 'PADDED_BOARD_SPLINT_WRAP'],
  },
  {
    key: 'PADDED_BOARD_SPLINT_WRAP_SHORT',
    category: 'SPLINTING',
    treatment: 'PADDED_BOARD_SPLINT',
    label: {
      en: 'Padded Board Splint Wrap Short'
    },
    location: 'LOWER_ARM',
    availableLocations: [
      'RIGHT_ARM_LOWER',
      'LEFT_ARM_LOWER',
    ],
  },
  {
    key: 'PELVIC_BINDER',
    category: 'SPLINTING',
    treatment: 'PELVIC_BINDER',
    label: {
      en: 'Pelvic Binder',
    },
    availableLocations: [
      'GENITALIA',
    ],
    availableStances: [
      'LAY',
    ],
    allMoulages: true,
  },
  {
    key: 'BLANKET_ARMS_IN',
    category: 'ENVIRONMENTAL',
    treatment: 'BLANKETS',
    type: 'BLANKET_ARMS_IN',
    label: {
      en: 'Blankets Arms In'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
      'FOWLER',
    ],
    incompatibleMoulages: [
      'AMPUTATION_CLEAN_UPPER',
      'AMPUTATION_MESSY_UPPER',
      'AMPUTATION_BLAST_UPPER',
      'AMPUTATION_CLEAN_LOWER',
      'AMPUTATION_MESSY_LOWER',
      'AMPUTATION_BLAST_LOWER',
      'AMPUTATION_CLEAN_EXTREMITY',
      'AMPUTATION_MESSY_EXTREMITY',
      'AMPUTATION_BLAST_EXTREMITY',
    ],
    allMoulages: true,
  },
  {
    key: 'BLANKET_ARMS_OUT',
    category: 'ENVIRONMENTAL',
    treatment: 'BLANKETS',
    type: 'BLANKET_ARMS_OUT',
    label: {
      en: 'Blanket Arms Out'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
      'FOWLER',
    ],
    incompatibleMoulages: [
      'AMPUTATION_CLEAN_UPPER',
      'AMPUTATION_MESSY_UPPER',
      'AMPUTATION_BLAST_UPPER',
      'AMPUTATION_CLEAN_LOWER',
      'AMPUTATION_MESSY_LOWER',
      'AMPUTATION_BLAST_LOWER',
      'AMPUTATION_CLEAN_EXTREMITY',
      'AMPUTATION_MESSY_EXTREMITY',
      'AMPUTATION_BLAST_EXTREMITY',
    ],
    allMoulages: true,
  },
  {
    key: 'THERMAL_BLANKET_ARMS_IN',
    category: 'ENVIRONMENTAL',
    treatment: 'BLANKETS',
    type: 'THERMAL_BLANKET_ARMS_IN',
    label: {
      en: 'Thermal Blanket Arms In'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
      'FOWLER',
    ],
    incompatibleMoulages: [
      'AMPUTATION_CLEAN_UPPER',
      'AMPUTATION_MESSY_UPPER',
      'AMPUTATION_BLAST_UPPER',
      'AMPUTATION_CLEAN_LOWER',
      'AMPUTATION_MESSY_LOWER',
      'AMPUTATION_BLAST_LOWER',
      'AMPUTATION_CLEAN_EXTREMITY',
      'AMPUTATION_MESSY_EXTREMITY',
      'AMPUTATION_BLAST_EXTREMITY',
    ],
    allMoulages: true,
  },
  {
    key: 'THERMAL_BLANKET_ARMS_OUT',
    category: 'ENVIRONMENTAL',
    treatment: 'BLANKETS',
    type: 'THERMAL_BLANKET_ARMS_OUT',
    label: {
      en: 'Thermal Blanket Arms Out'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
      'FOWLER',
    ],
    incompatibleMoulages: [
      'AMPUTATION_CLEAN_UPPER',
      'AMPUTATION_MESSY_UPPER',
      'AMPUTATION_BLAST_UPPER',
      'AMPUTATION_CLEAN_LOWER',
      'AMPUTATION_MESSY_LOWER',
      'AMPUTATION_BLAST_LOWER',
      'AMPUTATION_CLEAN_EXTREMITY',
      'AMPUTATION_MESSY_EXTREMITY',
      'AMPUTATION_BLAST_EXTREMITY',
    ],
    allMoulages: true,
  },
  {
    key: 'LONG_SPINE_BOARD',
    category: 'IMMOBILIZATION',
    treatment: 'LONG_SPINE_BOARD',
    label: {
      en: 'Long Spine Board'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
    ],
    allMoulages: true,
  },
  {
    key: 'CERVICAL_COLLAR',
    category: 'IMMOBILIZATION',
    treatment: 'CERVICAL_COLLAR',
    label: {
      en: 'Cervical Collar'
    },
    availableLocations: [
      'NECK',
    ],
    availableStances: [
      'SIT',
      'LAY',
      'FOWLER',
      'SIDE',
    ],
    allMoulages: true,
  },
  {
    key: 'STRAPS_ARMS_IN',
    category: 'IMMOBILIZATION',
    treatment: 'STRAPS',
    type: 'STRAPS_ARMS_IN',
    label: {
      en: 'Straps Arms In'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
      'FOWLER',
    ],
    allMoulages: true,
  },
  {
    key: 'STRAPS_ARMS_OUT',
    category: 'IMMOBILIZATION',
    treatment: 'STRAPS',
    type: 'STRAPS_ARMS_OUT',
    label: {
      en: 'Straps Arms Out'
    },
    availableLocations: [
      'FULL_BODY',
    ],
    availableStances: [
      'LAY',
      'FOWLER',
    ],
    allMoulages: true,
  },
];


const categoryLabel = {
  'BLEED_CONTROL': {
    en: 'Bleed Control'
  },
  'SPLINTING': {
    en: 'Splinting'
  },
  'CHEST_WOUNDS': {
    en: 'Chest Wounds'
  },
  'BURN_CARE': {
    en: 'Burn Care'
  },
  'ENVIRONMENTAL': {
    en: 'Environmental'
  },
  'IMMOBILIZATION': {
    en: 'Immobilization'
  },
};

const treatmentLabel = {
  'DIRECT_PRESSURE': {
    en: 'Direct Pressure'
  },
  'DRESSING': {
    en: 'Dressing'
  },
  'BANDAGE': {
    en: 'Bandage'
  },
  'SLING_SWATHE': {
    en: 'Sling and Swathe'
  },
  'SPLINTING': {
    en: 'Splinting'
  },
  'CHEST_SEAL': {
    en: 'Chest Seal'
  },
  'PETROLEUM_GAUZE': {
    en: 'Petroleum Gauze'
  },
  'TOURNIQUET': {
    en: 'Tourniquet'
  },
  'BANDAGE_DRY_STERILE_GAUZE': {
    en: 'Dry Sterile Gauze'
  },
  'NEEDLE_DECOMPRESSION': {
    en: 'Needle Decompression'
  },
  'MANUAL_STABILIZATION': {
    en: 'Manual Stabilization'
  },
  'PADDED_BOARD_SPLINT': {
    en: 'Padded Board Splint'
  },
  'PELVIC_BINDER': {
    en: 'Pelvic Binder'
  },
  'BLANKETS': {
    en: 'Blankets'
  },
  'LONG_SPINE_BOARD': {
    en: 'Long Spine Board'
  },
  'CERVICAL_COLLAR': {
    en: 'Cervical Collar'
  },
  'STRAPS': {
    en: 'Straps'
  },
};

const typeLabel = {
  '2X2': {
    en: '2 x 2'
  },
  '4X4': {
    en: '4 x 4'
  },
  'ROLLER_GAUZE': {
    en: 'Roller Gauze'
  },
  'ELASTIC': {
    en: 'Elastic'
  },
  'PRESSURE': {
    en: 'Pressure'
  },
  'AXILLARY_LEFT': {
    en: 'Axillary Left'
  },
  'AXILLARY_RIGHT': {
    en: 'Axillary Right'
  },
  'CLAVICULAR_LEFT': {
    en: 'Clavicular Left'
  },
  'CLAVICULAR_RIGHT': {
    en: 'Clavicular Right'
  },
  'GAUZE_MITTEN_WRAP': {
    en: 'Gauze Mitten Wrap'
  },
  'HARE_TRACTION_SPLINT': {
    en: 'Hare Traction Splint'
  },
  'SAGER_TRACTION_SPLINT': {
    en: 'Sager Traction Splint'
  },
  'SLING_SWATHE': {
    en: 'Sling and Swathe'
  },
  'SLING': {
    en: 'Sling'
  },
  'BLANKET_ARMS_IN': {
    en: 'Blankets Arms In'
  },
  'BLANKET_ARMS_OUT': {
    en: 'Blankets Arms Out'
  },
  'THERMAL_BLANKET_ARMS_IN': {
    en: 'Thermal Arms In'
  },
  'THERMAL_BLANKET_ARMS_OUT': {
    en: 'Thermal Arms Out'
  },
  'STRAPS_ARMS_IN': {
    en: 'Arms In'
  },
  'STRAPS_ARMS_OUT': {
    en: 'Arms Out'
  },
}

const locationLabel = {
  'PADDED_BOARD_SPLINT_FULL_LEG': {
    en: 'Full Leg'
  },
  'PADDED_BOARD_SPLINT_FULL_ARM': {
    en: 'Full Arm'
  },
  'PADDED_BOARD_SPLINT_WRAP_SHORT': {
    en: 'Lower Arm'
  },
};

interventions.interventions = interventions;
interventions.categoryLabel = categoryLabel;
interventions.treatmentLabel = treatmentLabel;
interventions.typeLabel = typeLabel;
interventions.locationLabel = locationLabel;

module.exports = interventions;
